import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

type Props = { children: ReactNode }
type State = { error: Error | null }

export default class RouteErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Route rendering failed', error, info)
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <section className="mx-auto max-w-xl py-10" aria-labelledby="route-error-title">
        <div className="card p-6 sm:p-8" role="alert">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-red-100 text-red-700 dark:bg-red-950/50 dark:text-red-300">
            <AlertTriangle size={20} aria-hidden="true" />
          </span>
          <h1 id="route-error-title" className="mt-4 text-xl font-semibold text-[rgb(var(--text-primary))]">This page could not be displayed</h1>
          <p className="mt-2 text-sm leading-relaxed text-[rgb(var(--text-muted))]">
            Your session is still active. Reload the page to try again; if the issue continues, return to My Access.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <button type="button" className="btn-primary" onClick={() => window.location.reload()}>
              <RefreshCw size={16} aria-hidden="true" /> Reload page
            </button>
            <a href="/" className="btn-secondary">My Access</a>
          </div>
        </div>
      </section>
    )
  }
}
